/* eslint-disable react/no-array-index-key */
import React from "react";
import { Table } from "react-bootstrap";

import Money from "web_modules/Money";
import { AppShape } from "@eave/shared/types/api";
import TaxSubsectionTable from "./TaxSubsectionTable";
import { compareSubsections } from "../../helpers";
import { ModifiedAggregationMap } from "../../shared";

const styles = require("../../styles.module.scss");

interface Props {
  app: AppShape;
  section: any;
  qualification_year_minus_two: string;
  qualification_year_minus_one: string;
  modifiedAggregations: ModifiedAggregationMap;
  setModifiedAggregations: React.Dispatch<React.SetStateAction<ModifiedAggregationMap>>;
}

const TaxSectionTable: React.FC<Props> = ({
  app,
  section,
  qualification_year_minus_two,
  qualification_year_minus_one,
  modifiedAggregations,
  setModifiedAggregations,
}: Props) => {
  // most recent year (year2) is shown first
  return (
    <Table
      key={section.section_key}
      className={`tax-return tax-return--subsection ${styles.incomeWorksheetTable}`}
    >
      <thead className="tax-return__header">
        <tr>
          <th>{section.heading}</th>
          <th>{qualification_year_minus_one}</th>
          <th>{qualification_year_minus_two}</th>
        </tr>
      </thead>
      {section.subsections.sort(compareSubsections).map((subsection, i) => (
        <TaxSubsectionTable
          app={app}
          key={`${section.section_key}-subsection-${i}`}
          section={section}
          subsection={subsection}
          hasSingleSubsection={section.subsections.length === 1}
          modifiedAggregations={modifiedAggregations}
          setModifiedAggregations={setModifiedAggregations}
        />
      ))}
      <tfoot className="tax-return__footer">
        <tr>
          <td />
          <td>Monthly Total:</td>
          <td>
            <Money value={section.monthly_total} />
          </td>
        </tr>
      </tfoot>
    </Table>
  );
};

export default TaxSectionTable;
